
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Download from "../pages/download/page";
import Terms from "../pages/terms/page";
import Privacy from "../pages/privacy/page";
import ChildSafety from "../pages/child-safety/page";
import Join from "../pages/join/page";
import Whakawhanaunga from "../pages/whakawhanaunga/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/downloads",
    element: <Download />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/child-safety",
    element: <ChildSafety />,
  },
  {
    path: "/join",
    element: <Join />,
  },
  {
    path: "/whakawhanaunga",
    element: <Whakawhanaunga />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
